import { Typography, Box } from '@mui/material';

const DocsScheduleCreate = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Create Time Table
      </Typography>

      <Typography variant="body1" paragraph>
        The timetable creation process generates a structured schedule based on
        the entered data. This ensures optimal allocation of classrooms,
        subjects, and teachers to all the class sessions.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Steps to Generate a Timetable
      </Typography>
      <Typography variant="body1" paragraph>
        Follow these steps to create a timetable:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Ensure all necessary data (departments, classrooms, subjects,
            teachers, students, and configuration) is entered correctly.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Schedule</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click the <strong>Create new schedule</strong> button.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            The system will process the data and generate an optimized
            timetable.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Once completed, you will be notified via email and a preview of the
            timetable will be available on the dashboard.
          </Typography>
        </li>
      </ul>
      <Typography variant="body1" paragraph>
        <strong>Note:</strong> Timetable generation may take some time depending
        on the complexity and size of the institution. You will receive an email
        upon completion.
      </Typography>

      {/* <Typography variant="h2" gutterBottom>
        Validations & Conflict Resolution
      </Typography>
      <Typography variant="body1" paragraph>
        If there are any conflicts (such as overlapping classes or unavailable teachers),
        the system will notify you to resolve the issues before finalizing the timetable.
      </Typography> */}
    </Box>
  );
};

export default DocsScheduleCreate;
